import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex: 1;
  gap: 1em;

  textarea {
    width: 500px;
    height: 250px;
  }

  label {
    display: block;
    margin-bottom: 1em;
  }
  .completion {
    border: 1px solid #ddd;
    width: 100%;
    padding: 1em;
    line-height: 1.2em;
  }
`;
